import {Component, OnDestroy, OnInit} from '@angular/core';
import {DynamicFormReadyEvent} from '../../../../projects/mydocma/dynamic-form/src/lib/events/dynamic-form-ready.event';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {ValidationError} from '../../../../projects/mydocma/dynamic-form/src/lib/validation/validation-error';
import {AbstractControl, UntypedFormGroup} from '@angular/forms';
import {
    CustomValidationError
} from '../../../../projects/mydocma/dynamic-form/src/lib/validation/custom-validation-error';
import {
    FieldTypeEnum,
    MultipleOptionType
} from '../../../../projects/mydocma/dynamic-form/src/lib/dynamic-field/field-type.enum';
import {
    DynamicFormAutofillService
} from '../../../../projects/mydocma/dynamic-form/src/lib/autofill/dynamic-form-autofill.service';
import {
    TextAreaFieldConfig
} from '../../../../projects/mydocma/dynamic-form/src/lib/fields/textarea/text-area-field.config';
import {NumberFieldConfig} from '../../../../projects/mydocma/dynamic-form/src/lib/fields/number/number-field.config';
import {DynamicFormConfig} from '../../../../projects/mydocma/dynamic-form/src/lib/dynamic-form/dynamic-form.config';
import {
    MultiOptionConfig
} from '../../../../projects/mydocma/dynamic-form/src/lib/fields/multi-option/multi-option.config';
import {
    FieldOrientationEnum,
    LabelPositionEnum
} from '../../../../projects/mydocma/dynamic-form/src/lib/fields/multi-option/multi-field.enums';
import {
    FilterSelectFieldConfig
} from "../../../../projects/mydocma/dynamic-form/src/lib/fields/filter-select/filter-select-field.config";

const DANGEROUS_OPTION_ID = 'dangerous';

@UntilDestroy()
@Component({
    selector: 'app-fill-form',
    templateUrl: './fill-form.component.html',
    styleUrls: ['./fill-form.component.scss']
})
export class FillFormComponent implements OnInit, OnDestroy {
    public formData: DynamicFormReadyEvent;
    public formGroup: UntypedFormGroup;
    public formConfig: DynamicFormConfig;
    public optionsConfig: DynamicFormConfig;

    public formData2: DynamicFormReadyEvent;
    public formGroup2: UntypedFormGroup;
    public formConfig2: DynamicFormConfig;
    public optionsConfig2: DynamicFormConfig;

    public defaultFields = [
        {
            id: 'select23',
            name: 'select23',
            type: FieldTypeEnum.filterSelect,
            label: {text: 'fields.select2'},
            required: true,
            openOnInit: true,
            allowAddItem: false,
            // value: 1,
            removeClearButton: true,
            // readonly: true,
            // customSearch: this.customSearchFn.bind(this),
            // multiline: true,
            source: [
                {id: 1, text: '1212'},
            ],

        } as FilterSelectFieldConfig,
        {
            id: 'select236',
            name: 'select236',
            type: FieldTypeEnum.filterSelect,
            label: {text: 'fields.select2'},
            required: false,
            openOnInit: true,
            allowAddItem: false,
            // value: 1,
            removeClearButton: true,
            // readonly: true,
            // customSearch: this.customSearchFn.bind(this),
            // multiline: true,
            source: [
                {id: 1, text: '1212'},
            ],

        } as FilterSelectFieldConfig,
        {
            id: 'select2367',
            name: 'select2367',
            type: FieldTypeEnum.filterSelect,
            label: {text: 'fields.select2'},
            required: false,
            openOnInit: true,
            allowAddItem: false,
            // value: 1,
            removeClearButton: true,
            // readonly: true,
            // customSearch: this.customSearchFn.bind(this),
            // multiline: true,
            source: [
                {id: 1, text: '1212'},
                {id: 2, text: '88888'},
            ],

        } as FilterSelectFieldConfig,
        {
            id: 'iconErrorTestField',
            name: 'iconErrorTestField',
            type: FieldTypeEnum.filterSelect,
            label: {text: 'Custom Error Icon Test Field'},
            required: true,
            source: [
                {id: 'safe', text: 'Safe Option'},
                {id: DANGEROUS_OPTION_ID, text: 'Dangerous Option (triggers error)'},
            ],
            validators: [this.iconErrorValidator.bind(this)]
        } as FilterSelectFieldConfig,
        {
            id: 'text1',
            name: 'text1',
            type: FieldTypeEnum.text,
            label: {text: 'fields.text1'},
            required: true,
            maxLength: 12,
            minLength: 3,
            disabled: false,
            value: '1',
            suffix: {
                tooltip: 'it is tooltop',
                icon: 'search',
            },

            hidden: false,
            validators: [this.badWordValidator.bind(this)],
            asyncValidators: [this.allBadWordValidator.bind(this)],
            prefix: {
                tooltip: 'it is tooltop',
                icon: 'search',
            }
        },
        {
            id: 'slideToggle8',
            name: 'slideToggle8',
            type: FieldTypeEnum.multiOption,
            label: {text: 'slideToggles'},
            class: 'additional-class',
            optionType: MultipleOptionType.slideToggle,
            source: {
                option1: 'fields.slideGroup.kyiv',
                option2: 'fields.slideGroup.lviv',
                option3: 'fields.slideGroup.cherkassy'
            },
            value: {
                option2: true,
                option3: true
            },
            orientation: FieldOrientationEnum.horizontal,
            labelPosition: LabelPositionEnum.after,
            hint:{
                text: 'This is a hint for the slide toggles',
                icon: {
                    iconName: '_info',
                    outlined: true
                }
            },
            validators: [this.toggleValidator.bind(this)],
        } as MultiOptionConfig,
        {
            id: 'textarea1',
            name: 'textarea1',
            type: FieldTypeEnum.textarea,
            label: {text: 'fields.textarea1'},
            required: true,
            // maxLength: 12,
            // minLength: 2,
            maxRows: 10,
            // minRows: 2,
            hidden: false,
            validators: [this.badWordValidator.bind(this)],
            asyncValidators: [this.allBadWordValidator.bind(this)],

        }
    ];
    public defaultFields2 = [
        {
            id: 'text1',
            name: 'text1',
            type: FieldTypeEnum.text,
            label: {text: 'fields.text1'},
            required: true,
            maxLength: 12,
            minLength: 3,
            disabled: false,
            value: '1',
            suffix: {
                tooltip: 'it is tooltop',
                icon: 'search',
            },

            hidden: false,
            validators: [this.badWordValidator.bind(this)],
            asyncValidators: [this.allBadWordValidator.bind(this)],
            prefix: {
                tooltip: 'it is tooltop',
                icon: 'search',
            }
        },
        {
            id: 'textarea1',
            name: 'textarea1',
            type: FieldTypeEnum.textarea,
            label: {text: 'fields.textarea1'},
            required: true,
            // maxLength: 12,
            // minLength: 2,
            maxRows: 10,
            minRows: 2,
            hidden: false,
            validators: [this.badWordValidator.bind(this)],
            asyncValidators: [this.allBadWordValidator.bind(this)]
        },
        {
            id: 'number1',
            name: 'number1',
            type: FieldTypeEnum.number,
            label: {text: 'fields.number1'},
            required: true,
            readonly: false,
            maxValue: 12,
        },
    ];

    public formErrors = true;
    public formVisibleErrors = false;
    public formAsterisk = false;
    public formInitValue;

    public formErrors2 = true;
    public formVisibleErrors2 = false;
    public formAsterisk2 = false;
    public formInitValue2;

    public emittedFormData: Array<{ fieldName: string, fieldValue: string }> = [];
    public emittedFormData2: Array<{ fieldName: string, fieldValue: string }> = [];

    constructor(private readonly dynamicAutofillService: DynamicFormAutofillService) {
    }

    public ngOnInit() {
        this.formConfig = {
            layouts: [],
            name: 'form1',
            fields: this.defaultFields
        };
        this.formConfig2 = {
            layouts: [],
            name: 'form2',
            fields: this.defaultFields2
        };
        this.optionsConfig = {
            layouts: [],
            name: 'form1',
            fields: [
                {
                    id: 'text1',
                    name: 'text1',
                    type: FieldTypeEnum.multiOption,
                    label: {text: 'text1'},
                    class: 'additional-class',
                } as MultiOptionConfig, {
                    id: 'textarea1',
                    name: 'textarea1',
                    type: FieldTypeEnum.textarea,
                    label: {text: 'textarea1'},
                    required: true,
                    // maxLength: 12,
                    // minLength: 2,
                    maxRows: 10,
                    // minRows: 2,
                    hidden: false,
                    validators: [this.badWordValidator.bind(this)],
                    asyncValidators: [this.allBadWordValidator.bind(this)]
                } as TextAreaFieldConfig
            ]
        };
        this.optionsConfig2 = {
            layouts: [],
            name: 'form2',
            fields: [{
                id: 'number1',
                name: 'number1',
                type: FieldTypeEnum.number,
                label: {text: 'number1'},
                required: true,
                readonly: false,
                maxValue: 12,
            } as NumberFieldConfig
            ]
        };

    }

    onOpenSelect(formName) {
        this.dynamicAutofillService.openAutofillSelect(formName);
    }

    public showEmittedData(formGroup: UntypedFormGroup, formName) {
        const newValue = [];
        for (const item of formGroup.value) {
            newValue.push({fieldName: item, fieldValue: formGroup.get(item).value});
        }
        if (formName === 'form1') {
            this.emittedFormData = newValue;
        }
        if (formName === 'form2') {
            this.emittedFormData2 = newValue;
        }
    }

    public async onReadyEvent(param: DynamicFormReadyEvent) {
        this.formData = param;
        this.formGroup = param.dynamicFormService.formGroup;
        this.formInitValue = this.formGroup.value;

        this.formData.dynamicFormEventsService.onControlPrefixClick
            .subscribe(e => {
                alert(`${e.name}: prefix click`);
            });

        this.formData.dynamicFormEventsService.onControlSuffixClick
            .subscribe(e => {
                alert(`${e.name}: suffix click`);
            });

        setTimeout(() => {
            this.formData.dynamicFormValidationService.formErrors$
                .pipe(untilDestroyed(this))
                .subscribe(errors => {
                    this.formErrors = false;
                    this.formVisibleErrors = false;

                    if (Object.keys(errors).length === 0) {
                        return;
                    }

                    this.formErrors = true;
                    for (const error of Object.values(errors)) {
                        if ((error as ValidationError).errorVisible) {
                            this.formVisibleErrors = true;
                            this.formAsterisk = this.formVisibleErrors;

                            return;
                        }
                    }

                    if (JSON.stringify(this.formGroup.value) === JSON.stringify(this.formInitValue)) {
                        this.formAsterisk = this.formVisibleErrors;
                    }
                });

            this.formGroup.valueChanges
                .pipe(untilDestroyed(this))
                .subscribe(formValue => {
                    if (JSON.stringify(formValue) === JSON.stringify(this.formInitValue)) {
                        this.formAsterisk = this.formVisibleErrors;

                        return;
                    }

                    this.formAsterisk = true;
                });
        });
    }

    public async onReadyEvent2(param: DynamicFormReadyEvent) {
        this.formData2 = param;
        this.formGroup2 = param.dynamicFormService.formGroup;
        this.formInitValue2 = this.formGroup2.value;

        this.formData2.dynamicFormEventsService.onControlPrefixClick
            .subscribe(e => {
                alert(`${e.name}: prefix click`);
            });
        await this.formData.dynamicFormService.autoFill();

        this.formData2.dynamicFormEventsService.onControlSuffixClick
            .subscribe(e => {
                alert(`${e.name}: suffix click`);
            });

        // this.dynamicAutofillService.autoFilterSelectValue(this.formGroup, this.defaultFields);

        setTimeout(() => {
            this.formData2.dynamicFormValidationService.formErrors$
                .pipe(untilDestroyed(this))
                .subscribe(errors => {
                    this.formErrors2 = false;
                    this.formVisibleErrors2 = false;

                    if (Object.keys(errors).length === 0) {
                        return;
                    }

                    this.formErrors2 = true;
                    for (const error of Object.values(errors)) {
                        if ((error as ValidationError).errorVisible) {
                            this.formVisibleErrors2 = true;
                            this.formAsterisk2 = this.formVisibleErrors2;

                            return;
                        }
                    }

                    if (JSON.stringify(this.formGroup2.value) === JSON.stringify(this.formInitValue2)) {
                        this.formAsterisk2 = this.formVisibleErrors2;
                    }
                });

            this.formGroup2.valueChanges
                .pipe(untilDestroyed(this))
                .subscribe(formValue => {
                    if (JSON.stringify(formValue) === JSON.stringify(this.formInitValue)) {
                        this.formAsterisk2 = this.formVisibleErrors2;

                        return;
                    }

                    this.formAsterisk2 = true;
                });
        });
    }

    public submitClick(formName) {
        if (formName === 'form1') {
            const isValid = this.formData.dynamicFormValidationService.validate();
            if (!isValid) {
                return;
            }

            this.dynamicAutofillService.saveAutofillValues(formName, this.formGroup);
            this.showEmittedData(this.formGroup, 'form1');
            this.formGroup.reset();
        }


        if (formName === 'form2') {
            const isValid = this.formData2.dynamicFormValidationService.validate();
            if (!isValid) {
                return;
            }

            this.dynamicAutofillService.saveAutofillValues(formName, this.formGroup2);
            this.showEmittedData(this.formGroup2, 'form2');
            this.formGroup2.reset();
        }
    }

    public creatNewForm(formName) {
        if (formName === 'form1') {
            this.dynamicAutofillService.fillForm(formName, this.formGroup);
            this.formGroup.updateValueAndValidity();

            return;
        }
        if (formName === 'form2') {
            this.dynamicAutofillService.fillForm(formName, this.formGroup2);
            this.formGroup2.updateValueAndValidity();
        }
    }

    public ngOnDestroy(): void {
    }

    private toggleValidator(control: AbstractControl): CustomValidationError {
        if (control.value['option1'] === false && control.value['option2'] === false && control.value['option3'] === false)
            return {
                mydocmaCustomError: 'at least one has to be toggled!!'
            };
    }

    private badWordValidator(control: AbstractControl): CustomValidationError {
        if (control.value && control.value.toLowerCase() === 'bad word') {
            return {
                mydocmaCustomError: 'bad words are not allowed'
            };
        }
    }

    private async allBadWordValidator(control: AbstractControl): Promise<CustomValidationError> {
        if (control.value && control.value.toLowerCase().trim().startsWith('bad word')) {
            return {
                mydocmaCustomError: 'all bad words are not allowed'
            };
        }
    }

    private iconErrorValidator(control: AbstractControl): CustomValidationError {
        const errorCondition = control.value === DANGEROUS_OPTION_ID;

        if (errorCondition) {
            return {
                mydocmaCustomError: 'The icon for this error message is configurable',
                mydocmaCustomErrorIcon: '_high-priority'
            };
        }
    }
}
